import useScrollReveal from '../../../hooks/utils/useScrollReveal';
import './wrapper_component.css';

function WrapperComponent({ children, options }) {
    const revealRef = useScrollReveal(options);

    return (
        <section ref={revealRef} className="wrapper-section">
            <div className="wrapper-container">
                {children}
            </div>
        </section>
    );
}

export default WrapperComponent;